import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, RocketIcon, LockIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function RoadmapSlide() {
  return <SlideLayout data-id="element-403">
      <motion.div variants={itemVariants} className="mb-20 text-center" data-id="element-404">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-405">
          Open Source First, Expanding Fast
        </h2>
      </motion.div>

      {/* Timeline */}
      <motion.div variants={itemVariants} className="relative max-w-5xl mx-auto mb-20" data-id="element-406">
        {/* Connecting Line */}
        <div className="absolute top-12 left-0 w-full h-1 bg-brand-border rounded-full z-0" data-id="element-407" />
        <div className="absolute top-12 left-0 w-1/3 h-1 bg-brand-teal rounded-full z-0 shadow-[0_0_10px_rgba(0,212,170,0.5)]" data-id="element-408" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-409">
          {/* NOW */}
          <div className="flex flex-col items-center" data-id="element-410">
            <div className="w-24 h-24 bg-brand-bg-card border-2 border-brand-teal rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(0,212,170,0.2)]" data-id="element-411">
              <RocketIcon className="w-10 h-10 text-brand-teal" data-id="element-412" />
            </div>
            <div className="bg-brand-teal/10 text-brand-teal font-bold px-4 py-1 rounded-full text-sm mb-4 border border-brand-teal/20" data-id="element-413">
              NOW
            </div>
            <div className="bg-brand-bg-card border border-brand-border rounded-xl p-6 w-full text-center" data-id="element-414">
              <h3 className="text-xl font-bold text-brand-text mb-4" data-id="element-415">
                Launch Models
              </h3>
              <ul className="space-y-2 text-brand-text-dim" data-id="element-416">
                <li className="font-medium text-brand-text" data-id="element-417">Llama 8B</li>
                <li className="font-medium text-brand-text" data-id="element-418">Llama 70B</li>
              </ul>
              <p className="text-xs text-brand-text-muted mt-4 pt-4 border-t border-brand-border" data-id="element-419">
                Fully optimized for FPGA inference
              </p>
            </div>
          </div>

          {/* NEXT */}
          <div className="flex flex-col items-center" data-id="element-420">
            <div className="w-24 h-24 bg-brand-bg border-2 border-brand-border rounded-full flex items-center justify-center mb-6" data-id="element-421">
              <ClockIcon className="w-10 h-10 text-brand-text-dim" data-id="element-422" />
            </div>
            <div className="bg-brand-bg-card text-brand-text-dim font-bold px-4 py-1 rounded-full text-sm mb-4 border border-brand-border" data-id="element-423">
              NEXT
            </div>
            <div className="bg-brand-bg-card/50 border border-brand-border rounded-xl p-6 w-full text-center" data-id="element-424">
              <h3 className="text-xl font-bold text-brand-text mb-4" data-id="element-425">
                Customer Driven
              </h3>
              <ul className="space-y-2 text-brand-text-dim" data-id="element-426">
                <li data-id="element-427">Qwen</li>
                <li data-id="element-428">Kimi</li>
                <li data-id="element-429">MiniMax 2.5 (430B)</li>
                <li data-id="element-430">GLM</li>
              </ul>
              <p className="text-xs text-brand-text-muted mt-4 pt-4 border-t border-brand-border" data-id="element-431">
                Prioritized by LOIs & design partners
              </p>
            </div>
          </div>

          {/* FUTURE */}
          <div className="flex flex-col items-center" data-id="element-432">
            <div className="w-24 h-24 bg-brand-bg border-2 border-brand-border border-dashed rounded-full flex items-center justify-center mb-6" data-id="element-433">
              <LockIcon className="w-10 h-10 text-brand-text-muted" data-id="element-434" />
            </div>
            <div className="bg-transparent text-brand-text-muted font-bold px-4 py-1 rounded-full text-sm mb-4 border border-dashed border-brand-border" data-id="element-435">
              FUTURE
            </div>
            <div className="bg-transparent border border-dashed border-brand-border rounded-xl p-6 w-full text-center" data-id="element-436">
              <h3 className="text-xl font-bold text-brand-text-dim mb-4" data-id="element-437">
                B2B Partnerships
              </h3>
              <p className="text-brand-text-muted text-sm" data-id="element-438">
                Closed-source foundation models through exclusive partnerships.
              </p>
              <p className="text-xs text-brand-text-muted mt-4 pt-4 border-t border-dashed border-brand-border" data-id="element-439">
                Available on the same API
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div variants={itemVariants} className="flex flex-col md:flex-row gap-6 max-w-4xl mx-auto" data-id="element-440">
        <div className="flex-1 bg-brand-bg-card border border-brand-border rounded-xl p-6 flex items-start gap-4" data-id="element-441">
          <div className="p-2 bg-brand-teal/10 rounded-lg" data-id="element-442">
            <ClockIcon className="w-5 h-5 text-brand-teal" data-id="element-443" />
          </div>
          <div data-id="element-444">
            <h4 className="font-bold text-brand-text mb-1" data-id="element-445">
              2-Week Turnaround
            </h4>
            <p className="text-sm text-brand-text-dim" data-id="element-446">
              Our compilation toolchain moves models from source weights to
              FPGA-optimized deployment in days, not months.
            </p>
          </div>
        </div>
        <div className="flex-1 bg-brand-bg-card border border-brand-teal/30 rounded-xl p-6 flex items-start gap-4 relative overflow-hidden" data-id="element-447">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-teal/5 blur-2xl rounded-full" data-id="element-448" />
          <div className="p-2 bg-brand-teal/10 rounded-lg relative z-10" data-id="element-449">
            <RocketIcon className="w-5 h-5 text-brand-teal" data-id="element-450" />
          </div>
          <div className="relative z-10" data-id="element-451">
            <h4 className="font-bold text-brand-text mb-1" data-id="element-452">
              You Drive the Priority
            </h4>
            <p className="text-sm text-brand-text-dim" data-id="element-453">
              Model priority is driven by you — if a model matters to your
              product, tell us and we will accelerate it.
            </p>
          </div>
        </div>
      </motion.div>
    </SlideLayout>;
}